var map = {
	"./ico-monitor.png": 511,
	"./ico-streaming.png": 512,
	"./noimg.jpg": 513
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 883;


//////////////////
// WEBPACK FOOTER
// ./src/app/website/pregao/assets/images ^\.\/.*$
// module id = 883
// module chunks = 2